module.exports = __webpack_public_path__ + "media/images/logo_landing_thumb-1981a1bd81a12ad866785079a79bfb02.png";